<template>
<div class="">

  <div class="row vpad"> 
    <div class="col s4 m2 yo-align-center"><img src="../assets/logo.png" style="height:70px;"/></div>
          <div class="col s8 m10"><h2>{{$socio.contatto.row.cognome}} {{$socio.contatto.row.nome}}</h2> </div>
  </div>




  <blockquote style="margin:0;"  v-if="sellaReady">
    <div class="yo-text-n yo-bg-color-secondary white yo-align-center" style="padding:10px 0;">MODALITÀ DI PAGAMENTO</div>

    <div style="padding:30px 10px;">
      L'importo da pagare è di € {{online.row.importo}},00
      <br /><br />
      Premendo il pulsante "Procedi al pagamento" verrete reindirizzati sul sito di Banca Sella dove potrete scegliere la modalità di pagamento da voi preferita tra quelle disponibili:
      <ul>
        <li>Carta di Credito</li>
        <li style="text-align:justify;">MyBank rende più facili e più sicuri gli acquisti su Internet. Per quanto concerne la sicurezza, MyBank vi permette di pagare su Internet senza fornire agli esercenti alcun dettaglio del vostro conto corrente o altri dati relativi al pagamento. E per quanto riguarda la semplicità, con MyBank userete il vostro sistema di Online Banking, che già conoscete, da dove potrete dare ordine alla vostra banca di effettuare il pagamento a favore dell’esercente.</li>
        <li>Bonifico bancario: solo per i clienti Banca Sella</li>
      </ul>  
      Una volta completata la procedura sul sito di Banca Sella vi ricordiamo di non chiudere il browser e ritornare al sito cliccando sul pulsante presente a fine procedura.
    </div>
    <div class="row pad" style="margin-top:20px;">
      <div class="col s12 m8 offset-m2">
        <a :href="sellaUri" class="yo-pointer yo-bg-color-secondary white yo-align-center" style="background-color:#24A445;display:block;width:100%;border:none;height:48px;line-height:48px;">Procedi al pagamento</a>
      </div>
    </div>      
  </blockquote>



</div>
</template>

<script>
import dbItem from '../teras/dbItem'

export default {
  name: 'socio-pagamento',
  components: {
  },
  data() {
    return {
      sellaReady: false
      ,sellaUri:''
      ,sella: {}
      ,commissione: 1
      ,online: {}
    }
  },
  created () {
    console.log("Arrivo al socio-pagamento.vue")
    this.$teras.pageTitle = "Procedi al pagamento"
    
    this.online = new dbItem({database:'bm_limmsy_simgeped',table:'online'})
    this.online.new().then(async (data) => {
      console.log("^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ì")
      this.online.row.motivo = 1
      this.online.row.contatto = this.$socio.contatto.row.id
      this.online.row.inseritoil=this.$moment().format('YYYY-MM-DD HH:mm:ss')
      this.online.row.sezione = 1

      switch (this.$socio.contatto.row.tiposocio) {
        case 2401:
        this.online.row.importo = 40
        break;

        case 2402:
        this.online.row.importo = 20
        break;

        case 2403:
        this.online.row.importo = 20
        break;

        default:
        this.online.row.importo = 20
          break;
      }

      
      this.online.row.quote = JSON.stringify({id:this.$socio.societa,nuovo:1,anno:this.$socio.primoanno,importo:this.online.row.importo})
      this.online.row.browser = this.$teras.browser.name +' '+ this.$teras.browser.version +' '+ this.$teras.browser.os
      await this.online.save()
      this.onSella()

      var shopLogin = "9111411" //PRODUZIONE
      //var shopLogin = "GESPAY71800" //TEST

    })
    
  },
  methods: {
    async onSella() {

            /*
      
      codice: XX9107380
      password: 1652079976009

      URL per risposta positiva
      https://api.biomedia.net/sellaReumapedClient.php
      URL per risposta negativa
      https://limmsy.biomedia.net/tesoreriaReumapedko.html
      URL Server to Server
      https://api.biomedia.net/sellaReumaped.php


      */



      this.sellaReady = false
        var shopLogin = "9111411" //PRODUZIONE
        //var shopLogin = "GESPAY71800" //TEST
        
        var args = {
          shopLogin: shopLogin
          ,uicCode: 242
          ,shopTransactionId:  this.online.row.id
          ,amount: this.online.row.importo  //PRODUZIONE
          //,amount: 1 //TEST
          ,customInfo: 'TERAS_NOMINATIVO='+this.$socio.contatto.row.cognome+' '+this.$socio.contatto.row.nome+'*P1*TERAS_MOTIVO=Nuova Adesione SIMGEPED'

          //  ,Language: 2";
          //  ,customInfo'] = 'nominativo='.$sella->nominativo;//.'*P1*';
        }
        console.log(args)
        var urlWS = "https://ecomms2s.sella.it/gestpay/gestpayws/WSCryptDecrypt.asmx?WSDL" //PRODUZIONE
        //var urlWS = "https://testecomm.sella.it/gestpay/gestpayws/WSCryptDecrypt.asmx?WSDL" //TEST

        

        this.$axios.post(this.$axios.apiUrl+'vue/sella',{url:urlWS,action:'Encrypt',args: args}).then((response) => {
          this.sella = response.data.data.result
          if(this.sella.TransactionResult=='OK'){
             this.sellaReady = true
             this.sellaUri =  "https://ecomm.sella.it/pagam/pagam.aspx" //PRODUZIONE
             //this.sellaUri =  "https://testecomm.sella.it/pagam/pagam.aspx" //TEST
             this.sellaUri += "?a="+shopLogin+"&b="+this.sella.CryptDecryptString
          }
        })

    }

  }
}
</script>